import {React, useState} from "react";
import './assets/Destination.scss';

const Destination = (props) => {
    const [planet, setPlanet] = useState(props.dest[1]);
    
    const handlePlanet = (e) => {
        const child = e.target.parentNode.childNodes;
        for (let i = 0; i < child.length; i++){
            if ("planet active" == child[i].className){
                child[i].classList.remove("active");
            }
        }
        console.log(e.target.className);
        e.target.classList.add("active");
        for (let i = 0; i < child.length; i++){
            if ("planet active" == child[i].className){
                setPlanet(props.dest[i]);
            }
        }
    }

    return(

        <div id="destination">

            <section>
                <div>
                    <h3><span>01</span> Pick Your Destination</h3>
                    <img alt="planet" src={require(`${planet.images.png}`)}/>
                </div>

                <div>
                    <div className="planet-toggle">
                        <a className="planet" onClick={handlePlanet}>moon</a>
                        <a className="planet active" onClick={handlePlanet}>mars</a>
                        <a className="planet"  onClick={handlePlanet}>europa</a>
                        <a className="planet"  onClick={handlePlanet}>titan</a>
                    </div>

                    <h1>{planet.name}</h1>

                    <p>{planet.description}</p>

                    <hr/>

                    <div className="planet-facts">
                        <div>
                            <h4>Avg. Distance</h4>
                            <p>{planet.distance}</p>
                        </div>

                        <div>
                            <h4>Est. Travel Time</h4>
                            <p>{planet.travel}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Destination;